import { ParsedCustomizationType, parseOrderItemCustomizationContent } from "@/dto/order/CustomizationInfoDTO";
import OrderItemDTO from "@/dto/order/OrderItemDTO";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import CustomizationInfo from "./CustomizationInfo";
import CustomizationInfoV2 from "./CustomizationInfoV2";

interface OrderItemCustomizationInfoProps {
    orderItem: OrderItemDTO;
}

const OrderItemCustomizationInfo: React.FC<OrderItemCustomizationInfoProps> = observer(function (props) {
    const { orderItem } = props;

    const result = useMemo(() => parseOrderItemCustomizationContent(orderItem?.customizationInfo?.content), [
        orderItem?.customizationInfo?.content,
    ]);

    if (result.type === ParsedCustomizationType.LH_CUSTOMIZATION_V1) {
        return (
            <>
                {result.customizationInfos.map((info, key) => {
                    return <CustomizationInfo info={info} key={key} />;
                })}
            </>
        );
    }

    if (result.type === ParsedCustomizationType.PHONE_CASE_CUSTOMIZATION_V2) {
        return (
            <>
                {result.phoneCaseCustomizationInfos.map((info, key) => {
                    return <CustomizationInfoV2 info={info} key={key} />;
                })}
            </>
        );
    }

    return null;
});

export default OrderItemCustomizationInfo;
